import React from 'react';
import { Settings as SettingsIcon, User, Mail, Shield } from 'lucide-react';
import './pages.css';
import Breadcrumbs from '../components/ui/Breadcrumbs';
import { useAuth } from '../auth';

export default function SettingsPage() {
  const { user } = useAuth();

  return (
    <div className="page">
      <Breadcrumbs items={[{ label: 'Tableau de bord', to: '/' }, { label: 'Paramètres' }]} />
      <div className="page-header">
        <h1><SettingsIcon size={22} /> Paramètres</h1>
      </div>

      <div className="section">
        <h3 className="section-title">Profil</h3>
        <div className="summary-grid summary-grid-compact">
          <div className="summary-card">
            <div className="summary-label"><User size={13} style={{ verticalAlign: 'middle', marginRight: 4 }} />Nom</div>
            <div className="summary-value" style={{ fontSize: '1.1rem' }}>{user?.name || '—'}</div>
          </div>
          <div className="summary-card">
            <div className="summary-label"><Mail size={13} style={{ verticalAlign: 'middle', marginRight: 4 }} />Email</div>
            <div className="summary-value" style={{ fontSize: '1.1rem' }}>{user?.email || '—'}</div>
          </div>
          <div className="summary-card">
            <div className="summary-label"><Shield size={13} style={{ verticalAlign: 'middle', marginRight: 4 }} />Rôle</div>
            <div className="summary-value" style={{ fontSize: '1.1rem' }}>{user?.role === 'admin' ? 'Administrateur' : 'Utilisateur'}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
